import { FC } from 'react';

type DataSourceCardLabelProps = {
  label: string | number;
};

export const DataSourceCardLabel: FC<DataSourceCardLabelProps> = ({ label }) => {
  return <p className='text-3xl font-semibold text-brand-600'>{label}</p>;
};
